module.exports = __webpack_public_path__ + "img/42.30d2c465.jpg";